import { useState, useEffect } from "react";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  Divider,
  Tooltip,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import {
  ExpandLess,
  ExpandMore,
  Info as InfoIcon,
  Description as DescriptionIcon,
  Gavel as GavelIcon,
  Badge as BadgeIcon,
  ContactPhone as ContactPhoneIcon,
  Person as PersonIcon,
  HelpOutline as HelpOutlineIcon,
  Article as ArticleIcon,
  Assignment as AssignmentIcon,
  Home as HomeIcon,
} from "@mui/icons-material";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useAdminContext } from "../../hooks/UseAdminContext";
import DashboardIcon from "@mui/icons-material/Dashboard";

const getSectionIcon = (value, size = "medium") => {
  const iconProps = { fontSize: size };
  switch (value) {
    case "dashboard":
      return <DashboardIcon {...iconProps} />;
    case "getting_started":
      return <InfoIcon {...iconProps} />;
    case "visa_type_and_application_details":
    case "visa_type":
    case "application_details":
      return <AssignmentIcon {...iconProps} />;
    case "sponsor_or_reference_contact_information":
      return <ContactPhoneIcon {...iconProps} />;
    case "personal_information_about_the_applicant":
      return <PersonIcon {...iconProps} />;
    case "passport_details":
      return <BadgeIcon {...iconProps} />;
    case "criminal_record":
      return <GavelIcon {...iconProps} />;
    case "language_assessment_support_services":
      return <HelpOutlineIcon {...iconProps} />;
    case "required_documentation":
      return <DescriptionIcon {...iconProps} />;
    case "housing_option":
      return <HomeIcon {...iconProps} />;
    default:
      return <ArticleIcon {...iconProps} />;
  }
};

export default function NavSectionItem({ data }) {
  const [openDropdown, setOpenDropdown] = useState(false);
  const {
    setSelectedQuestion,
    sectionList,
    selectedQuestion,
    hasUnsavedChanges,
    setShowUnsavedDialog,
    setActionToRunAfterLeavingUnsavedPage
  } = useAdminContext();
  const navigate = useNavigate();
  const { addon_id: paramAddonId, section, sub_section } = useParams();
  const location = useLocation();

  const addon_id =
    paramAddonId ||
    (location.pathname.includes("/visa/addon/")
      ? location.pathname.split("/")[3]
      : null);
  // --------------------------------
  const is_disable =
    selectedQuestion?.value === "getting_started" &&
    selectedQuestion?.questions?.[0]?.answer === "no";

  const dynamicTitle = data.title;

  useEffect(() => {
    if (data.has_sub_sections && section === data.value) {
      setOpenDropdown(true);
    }
  }, [section, data]);

  const isSubSectionActive = sub_section !== undefined;
  const isActiveSection = section === data.value;
  const isActiveSubSection = (subVal) => sub_section === subVal;

  const isPreviousSectionCompleted = () => {
    const index = sectionList.findIndex((sec) => sec.value === data.value);
    if (index === 0) return true;
    // Check if ALL previous sections are completed
    for (let i = 0; i < index; i++) {
      if (sectionList[i]?.is_completed !== true) {
        return false;
      }
    }
    return true;
  };

  const isCurrentDisabled =
    data.value === "dashboard"
      ? false
      : !isPreviousSectionCompleted() || is_disable;

  const handleClick = () => {
    if (!isCurrentDisabled) {
      if (data.has_sub_sections) {
        setOpenDropdown((prev) => !prev);
      } else {
        const isAddon = location.pathname.includes("/visa/addon/");
        const baseRoute = isAddon && addon_id ? `/visa/addon/${addon_id}` : "/visa";
        const newRoute = data.value === "dashboard" ? "/dashboard" : `${baseRoute}/${data.value}`;

        const performNav = () => {
          navigate(newRoute);
          if (data.value === "dashboard") {
            setSelectedQuestion(null);
          } else {
            let find_item = sectionList?.find((qes) => qes.value === data.value) || {};
            setSelectedQuestion(find_item);
          }
        };

        if (hasUnsavedChanges) {
          setActionToRunAfterLeavingUnsavedPage(() => performNav);
          setShowUnsavedDialog(true);
        } else {
          performNav();
        }
      }
    }
  };

  const handleSubSectionClick = (subSection) => {
    if (!is_disable) {
      const isAddon = location.pathname.includes("/visa/addon/");
      const baseRoute = isAddon && addon_id ? `/visa/addon/${addon_id}` : "/visa";
      const newRoute = `${baseRoute}/${data.value}/${subSection.value}`;

      const performNav = () => {
        navigate(newRoute);
        let selected = null;
        const parentItem = sectionList.find((qes) => qes.has_sub_sections === true);
        if (parentItem && Array.isArray(parentItem.sub_sections)) {
          selected = parentItem.sub_sections.find((qes) => qes.value === subSection.value);
        }
        setSelectedQuestion(selected);
      };

      if (hasUnsavedChanges) {
        setActionToRunAfterLeavingUnsavedPage(() => performNav);
        setShowUnsavedDialog(true);
      } else {
        performNav();
      }
    }
  };


  // ================ old code / Without unsaved Dialog states ================
  //   const handleClick = () => {
  //   if (!isCurrentDisabled) {
  //     if (data.has_sub_sections) {
  //       setOpenDropdown((prev) => !prev);
  //     } else {
  //       //  navigate(`/visa/${data.value}`);
  //       const isAddon = location.pathname.includes("/visa/addon/");
  //       const baseRoute = isAddon && addon_id ? `/visa/addon/${addon_id}` : "/visa";
  //       navigate(`${baseRoute}/${data.value}`);
  //       let find_item = {};
  //       if (sectionList.length > 0) {
  //         find_item = sectionList.find((qes) => qes.value === data.value);
  //       }
  //       setSelectedQuestion(find_item);
  //     }

  //     if (data?.value === "dashboard") {
  //       navigate("/dashboard");
  //       setSelectedQuestion(null);
  //     }
  //   }
  // };

  // const handleSubSectionClick = (subSection) => {
  //   if (!is_disable) {
  //     // navigate(`/visa/${data.value}/${subSection.value}`);
  //     const isAddon = location.pathname.includes("/visa/addon/");
  //     const baseRoute = isAddon && addon_id ? `/visa/addon/${addon_id}` : "/visa";
  //     navigate(`${baseRoute}/${data.value}/${subSection.value}`);

  //     let selected = null;

  //     const parentItem = sectionList.find(
  //       (qes) => qes.has_sub_sections === true
  //     );

  //     if (parentItem && Array.isArray(parentItem.sub_sections)) {
  //       selected = parentItem.sub_sections.find(
  //         (qes) => qes.value === subSection.value
  //       );
  //     }

  //     setSelectedQuestion(selected);
  //   }
  // };
  // ===========================================================

  const getTooltipMessage = () => {
    if (data.value === "dashboard") return "";
    if (!isPreviousSectionCompleted())
      return "Please complete the previous section first.";
    if (is_disable) return "Eligibility confirmation is required.";
    return "";
  };

  return (
    <>
      {data.has_sub_sections && (
        <Divider sx={{ marginY: 1, color: "black" }} className="mui-divider" />
      )}
      <Tooltip
        placement="top"
        title={getTooltipMessage()}
        disableHoverListener={!isCurrentDisabled}
        disableInteractive={false}
      >
        <span>
          <ListItemButton
            onClick={handleClick}
            className="menus-list"
            disabled={isCurrentDisabled}
            sx={{
              backgroundColor:
                isActiveSection && !isSubSectionActive ? "#15978a" : "inherit",

              color:
                isActiveSection && !isSubSectionActive ? "#fff" : "inherit",
              borderRadius: "4px",
              marginBottom: "4px",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              "& .sidebar-icons svg": {
                color:
                  isActiveSection && !isSubSectionActive ? "#fff" : "#15978a",
              },
              "&:hover": {
                backgroundColor: "#15978a",
                color: "#fff",
                "& .sidebar-icons svg": {
                  color: "#fff",
                },
              },
            }}
          >
            <div
              className="sidebar-icons"
              style={{ display: "flex", alignItems: "center" }}
            >
              {getSectionIcon(data.value)}
              <ListItemText
                primary={dynamicTitle ? dynamicTitle : data?.title}
                primaryTypographyProps={{
                  fontWeight: isActiveSection ? "400" : "400",
                  fontSize: "0.9rem",
                  marginLeft: 1,
                }}
              />
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              {data?.is_completed && (
                <CheckCircleIcon
                  className="mui-tick"
                  sx={{
                    color:
                      isActiveSection && !isSubSectionActive ? "#fff" : "green",
                    marginRight: data.has_sub_sections ? 1 : 0,
                  }}
                  fontSize="small"
                />
              )}

              {data.has_sub_sections &&
                (openDropdown ? <ExpandLess /> : <ExpandMore />)}
            </div>
          </ListItemButton>
        </span>
      </Tooltip>{" "}
      {data.has_sub_sections && (
        <Collapse in={openDropdown} timeout="auto" unmountOnExit>
          <List component="div" disablePadding className="sub-section-wrapper">
            {data.sub_sections.map((sub, idx) => {
              const subActive = isActiveSubSection(sub.value);

              const isSubDisabled =
                idx === 0
                  ? false
                  : data.sub_sections[idx - 1]?.is_completed !== true;
              return (
                <ListItemButton
                  key={idx}
                  onClick={() => {
                    handleSubSectionClick(sub);
                  }}
                  disabled={isSubDisabled}
                  className="menus-list child-menus-list"
                  sx={{
                    backgroundColor: subActive ? "#15978a" : "inherit",
                    color: subActive ? "#fff" : "inherit",
                    borderRadius: "4px",
                    marginBottom: "4px",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    "& .sidebar-icons svg": {
                      color: subActive ? "#fff" : "#15978a",
                    },
                    "&:hover": {
                      backgroundColor: "#15978a",
                      color: "#fff",
                      "& .sidebar-icons svg": {
                        color: "#fff",
                      },
                    },
                  }}
                >
                  <div
                    className="sidebar-icons"
                    style={{
                      marginLeft: "20px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {getSectionIcon(sub.value, "small")}
                    <ListItemText
                      primary={sub.title}
                      primaryTypographyProps={{
                        fontWeight: subActive ? "400" : "400",
                        fontSize: "0.85rem",
                        marginLeft: 1,
                      }}
                    />
                  </div>

                  {sub?.is_completed && (
                    <CheckCircleIcon
                      className="mui-tick"
                      sx={{ color: subActive ? "#fff" : "green" }}
                      fontSize="small"
                    />
                  )}
                </ListItemButton>
              );
            })}
          </List>
        </Collapse>
      )}
      {data.has_sub_sections && (
        <Divider sx={{ marginY: 1 }} className="mui-divider" />
      )}
    </>
  );
}
